module.exports = __webpack_public_path__ + "static/img/22.d4e3617.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/22.png
// module id = 8Hd4
// module chunks = 1